import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Notification } from "./types";

export type NotificationsState = {
  notification: Notification | null;
};

const initialState: NotificationsState = {
  notification: null
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<Notification>) => {
      state.notification = action.payload;
    },
    clear: () => initialState
  }
});

export const { showNotification, clear } = notificationsSlice.actions;

export const { actions: notificationsActions } = notificationsSlice;

export const reducer = notificationsSlice.reducer;
